import React from "react";
import PropTypes from "prop-types";
import {observer} from "mobx-react";
import {useValue} from "@morningtrain/react-resources";
import moment from "moment";

function Duration(props) {
    const {name, defaultValue} = props;

    let value = useValue(name, defaultValue);

    if (!value) return null;
    if (typeof value === 'string') return value;

    value = moment.duration(value, props.unit);

    return (!value) ? null : value.humanize();
}

Duration.defaultProps = {
    defaultValue: null,
    unit: 'seconds',
}

Duration.propTypes = {
    name: PropTypes.string.isRequired,
    defaultValue: PropTypes.any,
    unit: PropTypes.oneOf(['seconds', 'minutes', 'hours', 'days', 'weeks', 'months', 'years']),
}

export default observer(Duration);

